import PluginText from './PluginText';
import './style/index.less';

export default PluginText;
